module.exports = __webpack_public_path__ + "static/media/james.636835d9.png";